import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { IntlFormatters, useIntl } from 'react-intl';
import { useOryUserLogin } from '../../../../ory/hooks/oryUserLogin/useOryUserLogin';
import {
  defaultValues,
  FormFieldNames,
  getMFARecoveryFormValidationScheme,
  IMFARecoveryFormData,
} from './validationSchema';

export interface IUseMFARecoveryForm {
  formatMessage: IntlFormatters['formatMessage'];
  formSubmit: (values: IMFARecoveryFormData) => Promise<void>;
  formData: UseFormReturn<IMFARecoveryFormData, any, undefined>;
  isOryApiFetching: boolean;
}

export interface IUseMFARecoveryFormProps {
  onSuccess?: () => void;
}

export function useMFARecoveryForm(props: IUseMFARecoveryFormProps): IUseMFARecoveryForm {
  const { formatMessage } = useIntl();
  const { finishLoginWithSecondFactorRecoveryCode, isOryApiFetching } = useOryUserLogin();

  const formData = useForm<IMFARecoveryFormData>({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(getMFARecoveryFormValidationScheme(formatMessage)),
  });

  const formSubmit = async (values: IMFARecoveryFormData) => {
    await finishLoginWithSecondFactorRecoveryCode(
      { totpRecoveryCode: values.totpRecoveryCode },
      { fieldName: FormFieldNames.TotpRecoveryCode, formData },
      props.onSuccess
    );
  };

  return {
    formatMessage,
    formData,
    formSubmit,
    isOryApiFetching,
  };
}
